import React, { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [token, setToken] = useState(null);
  const [service_id, setServiceid] = useState(null);
  const [service_name, setServicename] = useState(null);
  const [subservice_id, setSubserviceid] = useState(null);
  const [timeperiod_id, setTimeperiodid] = useState(null);
  const [selectedCartItems, setSelectedCartItems] = useState([]);
  useEffect(() => {
    const savedUserData = localStorage.getItem("userData");
    const savedToken = localStorage.getItem("authToken");
    if (savedUserData) {
      const userdetails = JSON.parse(savedUserData);
      setUserData(userdetails);
    }
    const savedServiceId = localStorage.getItem("service_id");
    if (savedServiceId) {
      setServiceid(savedServiceId);
    }
    const savedSubserviceId = localStorage.getItem("subservice_id");
    if (savedSubserviceId) {
      setSubserviceid(savedSubserviceId);
    }
    const savedTimeperiods = localStorage.getItem("timeperiods");
    if (savedTimeperiods) {
      setTimeperiodid(savedTimeperiods);
    }
    if (savedToken) {
      // const usertoken = JSON.parse(savedToken);
      setToken(savedToken);
    }
  }, []);

  const updateServiceId = (id) => {
    setServiceid(id);
    localStorage.setItem("service_id", id);
  };

  const updateSubserviceId = (id) => {
    setSubserviceid(id);
    localStorage.setItem("subservice_id", id);
  };
  const updateTimeperiods = (id) => {
    setTimeperiodid(id);
    localStorage.setItem("timeperiod_id", id);
  };

  const contextValue = {
    userData,
    setUserData,
    token,
    setToken,
    service_id,
    setServiceid: updateServiceId,
    service_name,
    setServicename,
    subservice_id,
    setSubserviceid: updateSubserviceId,
    timeperiod_id,
    setTimeperiodid: updateTimeperiods,
    selectedCartItems,
    setSelectedCartItems
  };
  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};
